import { render, staticRenderFns } from "./item-notes-modal.vue?vue&type=template&id=708a06b3"
import script from "./item-notes-modal.vue?vue&type=script&lang=js"
export * from "./item-notes-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports